const createInfoWindowContent = store =>
    `<div class="store-tooltip">
        <div class="store-tooltip__title">${store.branchName}</div>
        <div class="store-tooltip__distance">${store.distance} miles</div>
        <button type="submit"
            class="button button-secondary"
            name="form[clickAndCollect][clickAndCollectBranchId]"
            value="${store.storeCode}"
        >
            Deliver to this store
        </button>
    </div>`;

export const setStoresMarkers = (stores, map, markerBounds) => {
    const infoWindow = new google.maps.InfoWindow();
    stores.forEach((store, index) => {
        const position = new google.maps.LatLng(store.latitude, store.longitude);
        const marker = new google.maps.Marker({
            position,
            map,
            icon: '../../../img/marker.svg',
            title: 'Currys Store',
            label: {
                text: `${index + 1}`,
                color: 'white',
                className: 'marker-count',
                fontWeight: 'bold',
            }
        });

        marker.addListener('click', () => {
            infoWindow.setContent(createInfoWindowContent(store));
            infoWindow.open(map, marker);
        });

        markerBounds.extend(position);
    });
};

export const setMapZoom = (map, markerBounds) => map.fitBounds(markerBounds);
